export default __webpack_public_path__ + "static/training-catalog-en-23ef4f7c3f8aa1612979f72c31401200.webp";